import React, { Component } from 'react';

import {
    FormGroup,
    InputGroup,
    Button,
    ButtonToolbar,
    ControlLabel,
    FormControl,
    HelpBlock,
} from 'react-bootstrap';


class EventPlaceSearch extends Component {

    constructor(props) {
        super(props)
    }

    render() {

        const { input, label, meta } = this.props
        return (
            <div>
                <InputGroup>
                    {label && <ControlLabel>{label}</ControlLabel>}
                    <FormControl
                        type="text"
                        id="autocomplete"
                        {...input}
                        value={this.props.place}
                        onChange={this.props.placeTextBoxChange}
                        placeholder={this.props.placeholder}
                    />
                    {meta.touched &&
                        ((meta.error && <p className="alert alert-danger">{meta.error}</p>) ||
                            (meta.warning && <p className="alert alert-warning">{meta.warning}</p>))}
                </InputGroup>
            </div>
        );
    }


}

export default EventPlaceSearch;


// WEBPACK FOOTER //
// src/routes/tours/components/EventPlaceSearch.js